<template>
    <div class="app-container">
        <hear></hear>
        <div class="backoff">
            <div>
                <el-button @click="shuaxin" type="info" icon="el-icon-refresh-right" class="anniu"></el-button>
                <el-button class="anniu" @click="yesi">返回</el-button>
            </div>

        </div>
        <el-tabs style="flex:1" class="tac" tab-position="left">
            <el-tab-pane style="height: 100%;" label="基础信息">
                <el-form :model="form" label-width="170px" :disabled="true" class="fromsBox">
                    <el-form-item label="项目编号 :">
                        <el-input v-model="form.bidding_number" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="采购项目名称 :">
                        <el-input v-model="form.bidding_project_name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="采购方式 :">
                        <el-input v-model="form.bidding_type" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="预算金额 :">
                        <el-input v-model="form.margin_amount" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="包号 :">
                        <el-input v-model="form.bidding_project_number" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="来源:">
                        <el-input v-model="form.source" autocomplete="off"></el-input>
                    </el-form-item>
                      <!-- <el-form-item label="资金来源:">
                        <el-input v-model="form.guarantee_company_name" autocomplete="off"></el-input>
                    </el-form-item> -->
                       <!-- <el-form-item label="添加时间:">
                        <el-input v-model="form.guarantee_company_name" autocomplete="off"></el-input>
                    </el-form-item> -->
                </el-form>
            </el-tab-pane>
            <el-tab-pane style="height: 100%;" label="采购需求">
                <el-form :model="form"  :disabled="true" class="fromsBox">
                <el-form-item >
                  {{form.content}}
                        <!-- <el-input v-model="form.content" autocomplete="off"></el-input> -->
                    </el-form-item>

                </el-form>
            </el-tab-pane>
            <el-tab-pane style="height: 100%;" label="申请人资格需求">
 <el-input type="textarea" v-model="form.desc"></el-input>
            </el-tab-pane>
            <el-tab-pane style="height: 100%;" label="时间地点">
                <el-form :model="form" label-width="170px" :disabled="true" class="fromsBox">
                    <el-form-item label="开标时间 :">
                        <el-input v-model="form.company_name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开标地点 :">
                        <el-input v-model="form.corporate_information" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <binad></binad>


    </div>
</template>
    
<script>
import hear from ".././../components/hear.vue";
import binad from ".././../components/dinad.vue";
import shenhe from "@/view/Guarantee/shenhe.vue";
import jujue from "@/view/Guarantee/jujue.vue";
import chuhan from "@/view/Guarantee/chuhan.vue";
import guoqi from "@/view/Guarantee/guoqi.vue";
// import { bhdetail } from "@/api/system/liucheng";
export default {
    components: {
        hear,
        binad,
          guoqi,
    chuhan,
    jujue,
    shenhe,
    },
    data() {
        return {
            formLabelAlign: {},//申请公司信息
            chjg: {},//出汗机构
            shenqingInfo: {},//申请信息
            baohanFile: '',//保函文件
            shenpiFile: '',//审批文件
            payList: '',//支付记录
            kdList: '',//快递记录
            jinduInfo: {},//进度信息
            form:{

            },
        };
    },
    created() {
        //   this.get_weidaili();
        //   this.get_daili();
          console.log("Jeis",this.$route.query)
          this.form=this.$route.query
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        yesi(){
this.$router.push({
      path: '/sNavbar',
      query: {
         id: "tong2"
       }
 })
        },
        // 获取详情
        getDetail(id) {
            bhdetail({
                company_id: id
            }).then(res => {
                console.log(res);
                this.shenqingInfo=res.data.data.jiben
                this.formLabelAlign=res.data.data.shenqing_company
                this.shenqishenpiFilengInfo=res.data.data.ziliao
                this.baohanFile=res.data.data.baohan
                this.chjg=res.data.data.guarantee_company
                this.payList=res.data.data.pay
                this.kdList=res.data.data.kuaidi
                // this.jinduInfo=res.data.data.jiben
            })
        }
    },
};
</script>
<style scoped lang="scss">
.weidaili_head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.search {
    float: right;
    width: 20%;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;

    ::v-deep.el-input__inner {
        border: none !important;
    }

    .el-button {
        border: none;
    }
}

::v-deep.el-input__inner {
    border: none !important;
}

.weidaili {
    height: 75vh;
    margin-bottom: 10px;
    overflow: hidden;
}

.block {
    width: 95%;
    padding-right: 5%;
    display: flex;
    justify-content: flex-end;
}

.showphoto {
    height: 553px;
    background: #f5f6fa;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.showphoto1 {
    height: 553px;
    background: #f5f6fa;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.el-tabs .el-tab-pane {
    margin-top: 70px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // overflow-y: auto;
}

.app-container {
    height: 100%;
    padding-bottom: 0px;
    position: relative;
    display: flex;
    flex-direction: column;
    // position: relative;
}

// ::v-deep .el-tabs__content {
//   // height: 100% !important;
// }


.fromsBox {
    width: 70%;
    margin: 0px auto;
    margin-top: 60px;

    .el-form-item {
        margin-bottom: 4px;
        margin-left: 20px;
    }

}

.title {
    font-weight: bold;
    margin-bottom: 10px;
}

.left {
    width: 70%;
    margin: 0px auto;
    margin-top: 60px;
}

.conter {
    margin-left: 20px;
    // width: 85%;
}

.backoff {
    position: absolute;
    z-index: 999;
    left: 222px;
    top: 83px;
    // margin-left: 180px;
    display: flex;
    justify-content: flex-end;
    padding: 5px 0;
    box-sizing: border-box;

    div {
        width: calc(100vw - 240px);
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
    }

    .el-button {
        border: 1px solid;
    }
}

.rzBox {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%);

    .el-button {
        width: 150px !important;
    }
}

.renzhng {
    flex: 1;
    overflow-y: auto;
    padding: 0 10%;

    .el-form-item {
        margin-bottom: 4px;
    }
}

.footer {
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    height: 45px;
    // justify-content: center;
    align-items: center;
    background-color: #F4F4F5 !important;

    .btn {
        width: 80px;
        height: 35px;
        border: 1px solid #1795ff;
    }
}

.table {
    margin-top: 50px;
}
</style>
    


// WEBPACK FOOTER //
// src/view/agencies/details.vue